module.exports = __webpack_public_path__ + "static/media/bottom_shape_2_mob.96de400d.svg";